<template>
  <div v-if="isVisible" class="logout-modal-overlay" @click="handleOverlayClick">
    <div class="logout-modal" @click.stop>
      <h2 class="logout-modal-title">{{ $t('logout.title') }}</h2>
      <p class="logout-modal-message">{{ $t('logout.message') }}</p>
      <div class="logout-modal-buttons">
        <button class="logout-modal-btn logout-modal-btn-no" @click="handleNo">
          {{ $t('common.no') }}
        </button>
        <button class="logout-modal-btn logout-modal-btn-yes" @click="handleYes">
          {{ $t('common.yes') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoutModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleYes() {
      this.$emit('confirm');
    },
    handleNo() {
      this.$emit('cancel');
    },
    handleOverlayClick() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.logout-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.logout-modal {
  background: #2d3748;
  border-radius: 12px;
  padding: 32px 40px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.logout-modal-title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 12px 0;
  text-align: center;
}

.logout-modal-message {
  font-size: 14px;
  color: #a0aec0;
  margin: 0 0 28px 0;
  text-align: center;
}

.logout-modal-buttons {
  display: flex;
  gap: 12px;
}

.logout-modal-btn {
  flex: 1;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-modal-btn-no {
  background-color: #4a5568;
  color: #ffffff;
  
  &:hover {
    background-color: #5a6778;
  }
}

.logout-modal-btn-yes {
  background-color: #00d09c;
  color: #1a202c;
  
  &:hover {
    background-color: #00e0a8;
  }
}
</style>
